var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('PqHeader'),_c('br'),_c('PqPic'),_c('br'),_c('div',{staticClass:"row gutters"},[_c('PqDetails'),_c('PqParticipants')],1),_c('br'),_c('PqButtons')],1)}
var staticRenderFns = []

export { render, staticRenderFns }